import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "Email Address Verification", -1)
const _hoisted_2 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Info = _resolveComponent("Info")!

  return (_openBlock(), _createBlock(_component_Info, { class: "border-warning border border-dashed p-0 bg-light-warning rounded" }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", null, [
        _createTextVNode(" Please check your inbox and follow the link to verify your email address. If you didn't get an email, click "),
        _createElementVNode("a", {
          disabled: _ctx.sending,
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleClick && _ctx.handleClick(...args))),
          class: "",
          style: {"cursor":"pointer"}
        }, "this link", 8, _hoisted_2),
        _createTextVNode(" to request a new one. ")
      ])
    ]),
    _: 1
  }))
}